import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const TargetPropTypes = PropTypes.shape({
    _id: PropTypes.string,
    targetName: PropTypes.string,
    slab: PropTypes.arrayOf(PropTypes.shape({
        target: PropTypes.number,
        reward: PropTypes.number,
        isRewardPercentage: PropTypes.bool,
        achievementReward: PropTypes.number,
        isAchievementRewardPercentage: PropTypes.bool,
    })),
    agentId:PropTypes.array
});

export const TargetSlabDefaultProps = {
    achievementReward: 0,
    isRewardPercentage: true,
    isAchievementRewardPercentage: true,
};

export const TargetDefaultProps = {
    targetName: '',
    slab: [],
    tempSlab: { ...TargetSlabDefaultProps },
    agentId:[]
};

export const TargetYupSchema = Yup.object().shape({
    targetName: Yup.string().required('Required'),
});

export default {
    TargetSlabDefaultProps,
    TargetDefaultProps,
    TargetPropTypes,
    TargetYupSchema,
};
